export const en = {
    youAreCurrentlyUsing: 'You are currently using',
    outOf: 'out of ',
    teamMembers: 'Team members',
    members: 'Members',
    followingPeople: 'The following people have access to projects within this Organization.',
    needMore: 'Need more? ',
    upgradeHere: 'Upgrade here',
    manageJiraUsersTitle: 'Manage users between BugHerd and Jira',
    manageJiraUsersContent: 'this will allow you to match the users that are assigned and @mentioned on tasks across BugHerd and Jira',
  };
  
  export type Translations = typeof en;
  